import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../../styles/ContactForm.css';

export default function ContactUs() {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required.';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Invalid email address.';
    }
    if (!formData.phone.trim()) newErrors.phone = 'Phone number is required.';
    if (!formData.message.trim()) newErrors.message = 'Please enter your message.';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validation = validate();
    if (Object.keys(validation).length > 0) {
      setErrors(validation);
      return;
    }
  
    setLoading(true);
    setErrors({});
  
    try {
      let apiUrl = process.env.REACT_APP_API_URL || '';
      apiUrl = apiUrl.replace(/\/$/, ''); // Remove trailing slash if exists
      const res = await fetch(`${apiUrl}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
  
      const data = await res.json();
  
      if (data.success) {
        setFormData({ name: '', email: '', phone: '', message: '' });
        setShowModal(true);
      } else {
        alert(data.message || '❌ Failed to send message. Please try again later.');
      }
    } catch (err) {
      console.error('Submission error:', err);
      alert('⚠️ Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <>
      <form className="contact-form" onSubmit={handleSubmit} noValidate>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">Full Name</label>
          <input
            type="text"
            id="name"
            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <div className="invalid-feedback">{errors.name}</div>}
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email</label>
          <input
            type="email"
            id="email"
            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
            placeholder="you@example.com"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <div className="invalid-feedback">{errors.email}</div>}
        </div>

        <div className="mb-3">
          <label htmlFor="phone" className="form-label">Phone</label>
          <input
            type="tel"
            id="phone"
            className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
            placeholder="+60..."
            value={formData.phone}
            onChange={handleChange}
          />
          {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
        </div>

        <div className="mb-3">
          <label htmlFor="message" className="form-label">Message</label>
          <textarea
            id="message"
            className={`form-control ${errors.message ? 'is-invalid' : ''}`}
            rows="4"
            placeholder="How can we help you?"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          {errors.message && <div className="invalid-feedback">{errors.message}</div>}
        </div>

        <button type="submit" className="btn btn-dark w-100" disabled={loading}>
          {loading ? (
            <span><i className="bi bi-arrow-repeat me-2 spinner-border spinner-border-sm"></i>Sending...</span>
          ) : (
            <span><i className="bi bi-send-fill me-2"></i>Send Message</span>
          )}
        </button>
      </form>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>🎉 Message Sent Successfully</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Thank you for contacting us! Your message has been received and we’ll get back to you as soon as possible.</p>
          <p className="mb-0 text-muted">Usually within 1–3 business days.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setShowModal(false)}>Got it!</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
